var Device = /** @class */ (function () {
    function Device() {
    }
    return Device;
}());
export { Device };
export var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["MOBILE"] = 0] = "MOBILE";
    DeviceType[DeviceType["TABLET"] = 1] = "TABLET";
    DeviceType[DeviceType["DESKTOP"] = 2] = "DESKTOP";
})(DeviceType || (DeviceType = {}));
